export function clearRedux() {
  return {
    type: 'CLEAR_REDUX'
  }
}
